interface ExpenseTitle {
  title?: string
  merchantName?: string
  id?: string | number
}

/**
 * Determines the expense title that will be displayed
 *
 * @param {string} title User generated title of the expense
 * @param {string} merchantName Merchant name of the swipe
 * @param {string} id Expense ID
 * @returns {string} The title that is used for display purposes
 */
export const getExpenseTitle = ({
  title,
  merchantName,
  id,
}: ExpenseTitle = {}): string =>
  title || merchantName || (id ? `Expense #${id}` : 'Expense')
